type BuildMoneykitExchangeLinkVariablesParams = {
  readonly exchangeToken: string;
  readonly clientUserId: string | null | undefined;
  readonly replacingProviderAccountId: string | null | undefined;
  readonly isMagicLinkRequest: boolean;
};

type MoneykitExchangeLinkVariables = {
  readonly exchangeToken: string;
  readonly userId?: string;
  readonly replacingProviderAccountId?: string;
};

export function buildMoneykitExchangeLinkVariables({
  exchangeToken,
  clientUserId,
  replacingProviderAccountId,
  isMagicLinkRequest,
}: BuildMoneykitExchangeLinkVariablesParams): MoneykitExchangeLinkVariables {
  if (isMagicLinkRequest) {
    return { exchangeToken };
  }

  const userId =
    clientUserId !== null && clientUserId !== undefined && clientUserId.length > 0 ? clientUserId : undefined;
  const replacingId =
    replacingProviderAccountId !== null &&
    replacingProviderAccountId !== undefined &&
    replacingProviderAccountId.length > 0
      ? replacingProviderAccountId
      : undefined;

  if (userId === undefined && replacingId === undefined) {
    return { exchangeToken };
  }

  return {
    exchangeToken,
    ...(userId === undefined ? {} : { userId }),
    ...(replacingId === undefined ? {} : { replacingProviderAccountId: replacingId }),
  };
}

const MAGIC_LINK_AUTH_PREFIX = 'MagicLink ';

export function hasMagicLinkAuthorizationHeader(headers: Readonly<Record<string, string>>): boolean {
  const authorization = headers['authorization'];
  return authorization !== undefined && authorization.startsWith(MAGIC_LINK_AUTH_PREFIX);
}
